"use strict";
exports.__esModule = true;
exports.EMBED_RELINK_DIRECT_INTEGRATION = void 0;
exports.EMBED_RELINK_DIRECT_INTEGRATION = {
    HEADER: 'Confirm your property info',
    BODY: 'It looks like you already have a Flex account connected to a property. To continue, confirm that this is the property you want Flex to pay from now on.',
    PROPERTY_NAME: 'Property name',
    ADDRESS: 'Address',
    NOT_RIGHT_CTA: 'This isn’t right',
    CTA: 'Confirm'
};
